module.exports = "/_next/static/images/game-2-intro-tutorial-flashlight-uv-6f6a8a310e80f166ac5c08cb4da212af.png";